// ─── DESIGN TOKENS ───────────────────────────────────────────────────────────
export const C = {
  bg: '#ECEEF2',
  surface: '#ffffff',
  border: '#E2E5EA',
  borderMd: '#CDD0D8',
  text: '#111827',
  sub: '#6B7280',
  muted: '#9CA3AF',
  accent: '#2563EB',
  accentLt: '#EFF4FF',
  accentMd: '#BFCFFE',
  green: '#059669',
  greenLt: '#ECFDF5',
  amber: '#D97706',
  amberLt: '#FFFBEB',
  red: '#DC2626',
  redLt: '#FEF2F2',
  purple: '#7C3AED',
  purpleLt: '#F5F3FF',
};

export const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const SNAP_SIZE = 8;

// ─── LIBRARY DEFINITION ──────────────────────────────────────────────────────
export const LIBRARY = [
  {
    group: 'Layout',
    items: [
      { type: 'page_header', label: 'Page Header', icon: '▬', desc: 'Title + actions bar' },
      { type: 'section', label: 'Section Card', icon: '□', desc: 'Card with heading' },
      { type: 'flex_row', label: 'Flex Row', icon: '↔', desc: 'Horizontal flex container' },
      { type: 'flex_col', label: 'Flex Column', icon: '↕', desc: 'Vertical flex container' },
      { type: 'grid_container', label: 'Grid', icon: '⊞', desc: 'CSS grid with assignable cells' },
      { type: 'free_div', label: 'Free Div', icon: '▢', desc: 'Plain div, full style control' },
      { type: 'columns', label: 'Columns', icon: '⊟', desc: 'Equal column layout' },
      { type: 'divider', label: 'Divider', icon: '─', desc: 'Horizontal separator' },
    ],
  },
  {
    group: 'Data Display',
    items: [
      { type: 'stat_card', label: 'Stat Card', icon: '◈', desc: 'KPI metric with trend' },
      { type: 'data_table', label: 'Data Table', icon: '⊟', desc: 'Rows & columns' },
      { type: 'chart_bar', label: 'Bar Chart', icon: '▦', desc: 'Comparative bar chart' },
      { type: 'chart_line', label: 'Line Chart', icon: '∿', desc: 'Trend line chart' },
      { type: 'chart_pie', label: 'Pie / Donut', icon: '◔', desc: 'Pie or donut chart' },
      { type: 'badge', label: 'Badge', icon: '●', desc: 'Status tag' },
    ],
  },
  {
    group: 'Forms',
    items: [
      { type: 'fb_input', label: 'Input Field', icon: '▭', desc: 'Text / number / email' },
      { type: 'fb_dropdown', label: 'Dropdown', icon: '⌄', desc: 'Single or multi-select' },
      { type: 'fb_date', label: 'Date Picker', icon: '▦', desc: 'Day / month / year' },
      { type: 'fb_textarea', label: 'Text Area', icon: '≡', desc: 'Multiline input' },
      { type: 'fb_file', label: 'File Upload', icon: '↑', desc: 'Upload with path config' },
      { type: 'search_bar', label: 'Search Bar', icon: '⌕', desc: 'Search input' },
    ],
  },
  {
    group: 'Actions',
    items: [
      { type: 'btn_primary', label: 'Primary Button', icon: '▶', desc: 'Main CTA' },
      { type: 'btn_secondary', label: 'Secondary Button', icon: '▷', desc: 'Secondary action' },
      { type: 'btn_danger', label: 'Danger Button', icon: '✕', desc: 'Destructive action' },
    ],
  },
  {
    group: 'Content',
    items: [
      { type: 'text_block', label: 'Text Block', icon: 'T', desc: 'Heading or body text' },
      { type: 'alert_box', label: 'Alert Banner', icon: '!', desc: 'Info / success / warning / error' },
      { type: 'empty_state', label: 'Empty State', icon: '◌', desc: 'No-data placeholder' },
      { type: 'image_block', label: 'Image', icon: '⬜', desc: 'Image with caption' },
      { type: 'rich_html', label: 'Custom HTML', icon: '<>', desc: 'Raw HTML block' },
    ],
  },
];

export const LIB_FLAT = LIBRARY.flatMap((g) => g.items);
export const libFind = (type) => LIB_FLAT.find((i) => i.type === type) || { label: type, icon: '□' };

// ─── BORDER STYLES ───────────────────────────────────────────────────────────
export const BORDER_STYLES = ['none', 'solid', 'dashed', 'dotted', 'double'];
export const FONT_WEIGHTS = [
  { v: 300, l: 'Light' }, { v: 400, l: 'Regular' }, { v: 500, l: 'Medium' },
  { v: 600, l: 'Semibold' }, { v: 700, l: 'Bold' },
];
export const INPUT_TYPES = [
  { v: 'text', l: 'Text' }, { v: 'integer', l: 'Integer' }, { v: 'decimal', l: 'Decimal' },
  { v: 'email', l: 'Email' }, { v: 'password', l: 'Password' }, { v: 'number', l: 'Number' },
  { v: 'url', l: 'URL' }, { v: 'tel', l: 'Phone' },
];
export const DATE_TYPES = [
  { v: 'day', l: 'Day (DD/MM/YYYY)' }, { v: 'month', l: 'Month (MM/YYYY)' }, { v: 'year', l: 'Year' },
];
